export default class TemplateBlogsPage {
    constructor(container, apiEndpoint, tags, blogId, blogLandingUrl, options) {
        
        const defaultOptions = {
            sideContainer: '.template-blogs-page',
            itemsContainer: '.template-blogs-page .items',   
            banner: '.banner'        
        };

        this.options = Object.assign({}, defaultOptions, options);
        
        this.apiEndpoint = apiEndpoint;
        this.tags = tags;
        this.blogId = blogId;
        this.blogLandingUrl = blogLandingUrl;
        
        this.container = document.querySelector(container);
        this.itemsContainer = this.container.querySelector(this.options.itemsContainer);
        this.sideContainer = this.container.querySelector(this.options.sideContainer);
        this.banner = this.container.querySelector(this.options.banner);

        this.init();
    }

    init() {
                
        fetch(this.apiEndpoint)
            .then(response => response.json())
            .then(items =>  {
                                
                const filteredItems = items.filter(blogItem => this.filterBlogs(blogItem))
                                            .sort((a, b) => new Date(b.date) - new Date(a.date))
                                            .slice(0, 3); 

                if (filteredItems.length > 0)
                    this.renderItems(filteredItems);
                else
                    this.banner.style.display = 'none';

                this.sideContainer.classList.remove('loading');
            });
    }
    


    filterBlogs(blogItem){

        if(this.blogId !== 0 && this.blogId === blogItem.id)
            return false;
           
        return blogItem.tags
                    .some(blogTag => 
                            this.tags.some(tag =>
                                 tag == blogTag.key));

    }


    renderItems(items){

        let html = "";

        items.forEach(item=> {

            var imageUrl = item.images.listImageUrl;

            html+= `<div class="blog-item">
                        <a href="${item.url}">
                            <picture>
                                <img class="blog-image" src="${imageUrl}" alt="${item.imageAltText}" />
                            </picture>
                        </a>
                        <div class="blog-content">
                            <span class="blog-properties">
                                <span class="date">${item.dateFormatted}</span> | <span class="tags">${this.renderTags(item)}</span>                                
                            </span>
                            <a href="${item.url}">
                                <h3 class="blog-title">${item.name}</h3>                            
                                <p class="text">${item.text.substring(0, 100)}...</p>
                            </a>
                        </div>
                    </div>`; 
        });

        this.itemsContainer.innerHTML = html;        

    }

    renderTags(blogItem){

        let html = '';
        const lastTagKey = blogItem.tags[blogItem.tags.length - 1].key;

        blogItem.tags.forEach(tag=> {

            const comma = lastTagKey !== tag.key ? ',' : '';
            html += `<a class="tag"
                        href="${this.blogLandingUrl}?tag=${tag.key}"
                        title="${tag.name}">
                        ${tag.name}
                        ${comma}
                    </a>`;

        });        

        return html;
    }
}